import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import GradientButton from "../../component/GradientButton/GradientButton";
import TextInputOutline from "../../component/TextInputOutline/TextInputOutline";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import ButtonTabbar from "../../component/ButtonTabbar";
import constants from "../../config/constants";
import { isNetworkRequestFailedError } from "../../config/helpers";

const OPTIONS = [
  { label: "Password", value: "password" },
  { label: "Username", value: "username" },
];

class ForgotPassword extends Component {
  state = {
    isLoading: false,
    username: "",
    usernameError: "",
    pinEmailPhone: "",
    pinEmailPhoneError: "",
    method: 1,
    selectedTab: OPTIONS[0],
  };

  componentDidMount() {
    const { history, setHistory } = this.props;
    setHistory(history);
  }

  forgotPassword = async (e) => {
    e.preventDefault();
    const { localHistory, setAlertMessage } = this.props;

    try {
      const { method, username } = this.state;

      const payload = {
        username,
        smsOrEmail: method,
      };

      if (this.validate()) return;

      this.setState({ isLoading: true });

      let response;

      if (this.state.selectedTab?.value === "password") {
        response = await api.forgotPassword(payload);
      }

      if (this.state.selectedTab?.value === "username") {
        response = await api.forgotPasswordUsername({
          pinEmailPhone: this.state.pinEmailPhone,
        });
      }

      const { msg } = response.data;
      setAlertMessage({ type: "success", message: msg || "Success" });

      if (this.state.selectedTab?.value === "password") {
        localStorage.setItem("forgotusername", username);
        localHistory.push("/newpassword");
      }

      if (this.state.selectedTab?.value === "username") {
        localHistory.push("/login");
      }
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error)
          ? () => this.forgotPassword(e)
          : null,
      });
    }

    this.setState({ isLoading: false });
  };

  validate = () => {
    const errors = {};

    const { username, pinEmailPhone } = this.state;

    if (this.state.selectedTab?.value === "password") {
      if (!username) {
        errors.usernameError = "username is required!";
      }
    }

    if (this.state.selectedTab?.value === "username") {
      if (!pinEmailPhone.trim().length) {
        errors.pinEmailPhoneError = constants.VALIDATION_ERROR_MESSAGE;
      }
    }

    this.setState({ ...errors });

    return Object.keys(errors).length;
  };

  handleTabChange = (_newTab) => {
    if (_newTab.value === "password") {
      this.setState({ pinEmailPhone: "", pinEmailPhoneError: "" });
    }

    if (_newTab.value === "username") {
      this.setState({ username: "", usernameError: "" });
    }

    this.setState({ selectedTab: _newTab });
  };

  render() {
    const {
      username,
      isLoading,
      method,
      usernameError,
      pinEmailPhone,
      pinEmailPhoneError,
    } = this.state;

    return (
      <div className="login-main-container">
        <Container>
          <div className="login-container">
            <img
              alt="app-icon"
              src={require("../../assets/icons/app-icon.png")}
            />
            <p className="login-container-app-name">Premium Pension Limited</p>
            <div className="mt-5 mb-4">
              <ButtonTabbar
                onChange={this.handleTabChange}
                defaultSelected={OPTIONS[0]}
                selected={this.state.selectedTab}
                options={OPTIONS}
              />
            </div>
            <h2 className="mt-4 font-weight-bold">
              {this.state.selectedTab?.value === "password" &&
                "Forgot Password?"}
              {this.state.selectedTab?.value === "username" &&
                "Forgot Username?"}
            </h2>
            <form
              className="mb-5 mt-4 login-input-container align-items-start"
              onSubmit={this.forgotPassword}
            >
              {this.state.selectedTab?.value === "password" && (
                <TextInputOutline
                  onChange={(e) =>
                    this.setState({
                      username: e.target.value,
                      usernameError: "",
                    })
                  }
                  value={username}
                  label="Username"
                  errorMessage={usernameError}
                />
              )}
              {this.state.selectedTab?.value === "username" && (
                <TextInputOutline
                  onChange={(e) =>
                    this.setState({
                      pinEmailPhone: e.target.value,
                      pinEmailPhoneError: "",
                    })
                  }
                  value={pinEmailPhone}
                  label="PIN / Email / Phone"
                  errorMessage={pinEmailPhoneError}
                />
              )}

              {this.state.selectedTab?.value === "password" && (
                <div className="d-flex mt-4">
                  <CustomRadio
                    text="SMS"
                    isSelected={method === 1}
                    style={{ width: "100px" }}
                    onClick={() => this.setState({ method: 1 })}
                  />
                  <CustomRadio
                    text="Email"
                    isSelected={method === 2}
                    style={{ width: "100px" }}
                    onClick={() => this.setState({ method: 2 })}
                  />
                </div>
              )}
              <GradientButton
                type="submit"
                containerClasses="mt-4 mx-auto"
                label="Send Code"
              />
              <div className="text-center w-100 mt-2">
                <Link className="back-to-login-text" to="/login">
                  Already a member? Login
                </Link>
              </div>
            </form>
          </div>
        </Container>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);

const CustomRadio = (props) => (
  <div onClick={props.onClick} style={props.style} className="pointer">
    {props.isSelected ? (
      <img
        src={require("../../assets/icons/radio_1.png")}
        alt=""
        style={{ width: 20 }}
      />
    ) : (
      <img
        src={require("../../assets/icons/radio_2.png")}
        alt=""
        style={{ width: 20 }}
      />
    )}
    <span className="mx-1">{props.text}</span>
  </div>
);
